export const DEFAULT_SCRIPT_ID = 'cf-turnstile-script'
export const DEFAULT_SCRIPT_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'
export const DEFAULT_LOAD_TIMEOUT_MS = 10000
export const DEFAULT_POLL_INTERVAL_MS = 50
